// Backend/cms/src/services/help-support.service.ts
import { api } from './http-client';
import { ContactInfo, FaqItem, FaqListResponse } from '../types/help-support';

export const helpSupportService = {
  getContact: async (): Promise<ContactInfo> => {
    const res = await api.request<ContactInfo>({ url: '/system/contact', method: 'GET' });
    return res.data;
  },

  updateContact: async (data: Partial<ContactInfo>): Promise<ContactInfo> => {
    const res = await api.request<ContactInfo>({ url: '/system/contact', method: 'PUT', data });
    return res.data;
  },

  listFaqs: async (page = 1, limit = 50): Promise<FaqListResponse> => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    const res = await api.request<FaqListResponse>({
      url: `/admin/faqs?${params}`,
      method: 'GET',
    });
    return res.data;
  },

  createFaq: async (data: {
    question: string;
    answer: string;
    sortOrder?: number;
    isActive?: boolean;
  }): Promise<FaqItem> => {
    const res = await api.request<FaqItem>({ url: '/admin/faqs', method: 'POST', data });
    return res.data;
  },

  updateFaq: async (
    id: string,
    data: Partial<{ question: string; answer: string; sortOrder: number; isActive: boolean }>,
  ): Promise<FaqItem> => {
    const res = await api.request<FaqItem>({ url: `/admin/faqs/${id}`, method: 'PUT', data });
    return res.data;
  },

  deleteFaq: async (id: string): Promise<void> => {
    await api.request({ url: `/admin/faqs/${id}`, method: 'DELETE' });
  },

  reorderFaqs: async (items: Array<{ id: string; sortOrder: number }>): Promise<void> => {
    await api.request({ url: '/admin/faqs/reorder', method: 'PUT', data: { items } });
  },
};
